import { Injectable } from '@angular/core';
import { Headers, Http,RequestOptions,Response} from '@angular/http';

import {Observable} from 'rxjs/Observable';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class WebService {

	private token  = localStorage.getItem('token');
  	private headers = new Headers({'Content-Type': 'application/json',
  					'x-access-token': this.token,
  					
  					 });//'Access-Control-Allow-Origin':'localhost:3500'
  	private getheaders = new Headers({'Accept': 'application/vnd.com.kontakt+json;version=8','Api-Key': this.token });//'Access-Control-Allow-Origin':'localhost:3500'
	constructor(private http:Http) { 
    
  	}

  	uploadImage(url:string,files: any,obj:any){
  	return new Promise((resolve, reject) => {
  		//console.log("xxx");
	  	let headers = new Headers();
	    let formData:FormData = new FormData();
	    var xhr = new XMLHttpRequest();
	    //console.log("now check " + Array.isArray(files))
	    var listfiles:any;
	    if(Array.isArray(files)){
	    		try{
			    	var i=0;
			    	files.forEach(item=>{
			    	formData.append('files', item.img,item.img.name);	

			    	i++;
			    	//formData.append(files[i].name, files[i])
					})
					//formData.append('listFiles',files)
					console.log("data has been append")
			    	console.log(formData)
			    }catch(err){
			    	console.log(err)
			    }
	    }else if(files && files.name){
	    	 formData.append('files', files, files.name);
	 	}
	     
	      
	      for (var property in obj) {
	            if (obj.hasOwnProperty(property)) {
	            	if(typeof(obj[property]) === 'object'){
	            		formData.append(property, JSON.stringify(obj[property]));
	            	}else{
	            		formData.append(property, obj[property]);
	            	}
	                
	            }
	        }

	      // if(postData !=="" && postData !== undefined && postData !==null){
	      //   for (var property in postData) {
	      //       if (postData.hasOwnProperty(property)) {
	      //           formData.append(property, postData[property]);
	      //       }
	      //   }
	      // }

	              xhr.onreadystatechange = function () {
	                  if (xhr.readyState == 4) {
	                      if (xhr.status == 200) {
	                          resolve(JSON.parse(xhr.response));
	                      } else {
	                          reject(xhr.response);
	                      }
	                  }
	              }
	              xhr.timeout = 60000;
	              xhr.open("POST", url, true);
	              xhr.setRequestHeader('x-access-token',obj.token);
	              xhr.setRequestHeader('contentType','application/json; charset=utf-8');
	              xhr.setRequestHeader('Accept', 'application/json');
	              xhr.send(formData);
	    });
	    
	};



  	getResponse(url,obj){
  		return this.http
	    .post(url, JSON.stringify(obj), {headers: this.headers})
	    .toPromise()
	}

	getRequest(url,apikey){
		let getheaders = new Headers({'Accept': 'application/vnd.com.kontakt+json;version=8','Api-Key': apikey});
		return this.http
	    .get(url,{headers: getheaders})
	    .toPromise()
	}

	//added by vijay for add menu perpose
	getMethod(url){
		return this.http.get(url).toPromise()
	}
	//end here
	autoFillGet(url,term,token):Observable<any[]>{
		if (term === '') {
      		return Observable.of([]);
    	}
		//let getheaders = new Headers({'Accept': 'application/vnd.com.kontakt+json;version=8','Api-Key': apikey});
		let headers = new Headers({'Content-Type': 'application/json','x-access-token': this.token });
		return this.http
      		.get(url,{headers: headers})
      		.map(response => {
      			console.log(response.json());
      			return <string[]> response.json()['data'].slice(0, 10);
      		});
	}
  

}



// WEBPACK FOOTER //
// ./src/app/services/web/web.service.ts